import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { OperationService } from 'src/app/shared/service/operation/operation.service';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import * as FileSaver from 'file-saver';
import { MessageService } from 'primeng/api';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-consultaion-pdc',
  standalone: false,
  templateUrl: './consultaion-pdc.component.html',
  styleUrl: './consultaion-pdc.component.scss'
})

export class ConsultaionPdcComponent {
  searchTerm: string = '';
  firstProjets: number = 0;
  rowsProjets: number = 1;
  totalRecords: number = 0;
  filteredtems: any = [];
  paginatedProjets = [];
  filteredProjetData: any[] = [];
  programmeData: any[] = [];
  @ViewChild('detailModal') modalContent: TemplateRef<any>;
  selectedAction: string = "";
  selectedProgramma: any ;
  actionsList = [];

  programmeList = [];
  detailPdc: any = [];
  actionData: any = [];
  anneeDebut: any;
  anneesProgrammation: number[] = [ 0 ];
  isLoading: boolean = true;
  pdcData:any = []
  search_annee: any;
  selectedPdc: any;
  constructor(
    private paramService: ParameterService,
    private operationService: OperationService,
    private loader: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private modalService: NgbModal,
    private messageService: MessageService,

  ) { }

  ngOnInit() {
    this.anneeDebut = this.localStorage.getAnneeImportation() || 2023;

  // for (let i = 0; i < 5; i++) {
  //     this.anneesProgrammation.push(this.anneeDebut + i);
  //   }

    this.fetchProgramme();
    this.getPdc();
  }

    getPdc() {
    this.isLoading === false;
    this.paramService.getPdc().subscribe(
      (response: any) => {
        this.pdcData = response.data;
        this.isLoading = true;
        //console.log("this.pdcData", this.pdcData);
      },
      (error) => {
        //console.log("une erreur est survenu", error);
      }
    );
    }
  getConsultationPdc() {
    if (!this.search_annee) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: "Veuillez renseigner l'année" });
      return;
    }
    let requestData = {
      annee: this.search_annee
    }
    this.loader.start();
    this.detailPdc = []; this.filteredtems = []; this.totalRecords = 0; this.paginatedProjets = [];

    this.paramService.getConsultation(requestData).subscribe(
      (response: any) => {
        this.loader.stop();
        this.isLoading = true;
        this.detailPdc = response.data;
        this.filteredtems = [...this.detailPdc];
       this.totalRecords = this.detailPdc.length;
        //    this.fetchDataAction();
        this.anneesProgrammation = [ this.search_annee ];
        // for (let i = 0; i < 5; i++) {
        //   this.anneesProgrammation.push(this.search_annee + i);
        // }

        this.updatePaginatedProjets();
             // this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });

      },
      (error: any) => {
        this.isLoading = true;
        this.loader.stop();
           this.detailPdc = []; this.filteredtems = []; this.totalRecords = 0; this.paginatedProjets = [];
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error });

      }
    )
  }

searcheTeam:any;
  applyFilters(): void {
  this.searcheTeam = this.selectedProgramma.libelle
    let projetsFiltres = [...this.detailPdc];

    // Filtre par programme
    if (this.searcheTeam?.trim()) {
      projetsFiltres = projetsFiltres.filter(prog =>
        prog.libelle?.toLowerCase().includes(this.searcheTeam.trim().toLowerCase())
      );
    }

    // Filtre par action
    if (this.selectedAction?.trim()) {
      projetsFiltres = projetsFiltres.map(prog => {
        const actionsFiltrees = prog.actions?.filter(action =>
          action.libelle?.toLowerCase().includes(this.selectedAction.trim().toLowerCase())
        );
        return { ...prog, actions: actionsFiltrees };
      }).filter(prog => prog.actions?.length > 0);

   }

    // Recherche texte libre sur les activités
    if (this.searchTerm?.trim()) {
      const term = this.searchTerm.trim().toLowerCase();

      projetsFiltres = projetsFiltres.map(prog => {
        const actionsFiltrees = prog.actions.map(action => {
          const activitesFiltrees = action.details_pdc_activites?.filter(activite =>
            activite.libelle?.toLowerCase().includes(term) ||
            activite.code?.toLowerCase().includes(term) ||
            activite.indicateur?.libelle?.toLowerCase().includes(term) ||
            activite.service?.libelle?.toLowerCase().includes(term)
          );
          return { ...action, details_pdc_activites: activitesFiltrees };
        }).filter(action => action.details_pdc_activites?.length > 0);

        return { ...prog, actions: actionsFiltrees };
      }).filter(prog => prog.actions?.length > 0);

    }

    this.filteredtems = projetsFiltres;
    this.totalRecords = this.filteredtems.length;
    this.updatePaginatedProjets();
  }

  onProgrammaChange(): void {
    this.selectedAction = '';
    this.applyFilters();

    const requestData = {
      programme_id: this.selectedProgramma.reference
    }
    this.paramService.getActionProgramme(requestData).subscribe(
      (response: any) => {
        ////console.log("la réponse du webservice", response);
        this.actionsList = response.data
      },
      (error: any) => {
        ////console.log("une erreur est survenu", error);

      }
    )
  }




  onPageChangeProjets(event) {
    this.firstProjets = event.first;
    this.rowsProjets = event.rows;
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.filteredtems.slice(start, end);
  }

  Consulter(item: any) {
    this.detailPdc = item;
    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }
  updateLine(item: any) {
    this.detailPdc = item;
    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }

  //imprime en pdf et excel
exportToDocument(typeDoc:any) {

  const requestData = {
    type_exportation: typeDoc,
    annee: this.search_annee
  };

  this.loader.start();

  this.paramService.printPdc(requestData).subscribe(
    (response: Blob) => {

      let filename = '';
      let mimeType = '';

      if (typeDoc === 'pdf') {
        filename = `Plan_de_developpement_communale_${this.search_annee}.pdf`;
        mimeType = 'application/pdf';

        const blob = new Blob([response], { type: mimeType });

        // TÉLÉCHARGEMENT DIRECT
        FileSaver.saveAs(blob, filename);

      } else {
        filename = 'Plan_de_developpement_communale.xlsx';
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

        const blob = new Blob([response], { type: mimeType });

        // TÉLÉCHARGEMENT UNIQUEMENT
        FileSaver.saveAs(blob, filename);
      }

      this.loader.stop();

      this.messageService.add({
        severity: 'success',
        summary: 'Export réussi',
        detail: `Le fichier ${typeDoc.toUpperCase()} a été généré avec succès`,
        life: 3000
      });
    },
        (error: any) => {
        this.loader.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
  );
}//end exportToDocument



  fetchDataAction() {
    this.paramService.fetchDataAction().subscribe(
      (response: any) => {
        this.actionsList = response.data;
        //console.log("this.actionData", this.actionsList);
      },
      (error) => {
        //console.log("une erreur est survenu", error);
      }
    );
  }

  fetchProgramme() {
    this.isLoading === false;
    this.paramService.fetchDataProgramme().subscribe(
      (response: any) => {
        this.programmeList = response.data;
        //console.log("this.programmeList ", this.programmeList);
      },
      (error) => {
        //console.log("une erreur est survenu", error);
      }
    );
  }

  getMontantParAnneePourActivite(financements: any[], annee: number): number {
    if (!financements || !Array.isArray(financements)) return 0;

    const financement = financements.find(f => +f.annee === +annee);
    return financement ? +financement.montant : 0;
  }

  close() {

  }



}
